var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","type":"text/css","media":"all","href":"/css/style-app.css"}}),_c('TheMain')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }